import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Container, Grid } from '@material-ui/core'
import { injectIntl } from 'react-intl'
import Button from '@material-ui/core/Button'

import AccountMenu from './AccountMenu'

import { caseSelector, teamLogoIsLoadingSelector, teamLogoSelector } from '../redux/selectors'
import makeStyles from '@material-ui/core/styles/makeStyles'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import CloseIcon from '@material-ui/icons/Close';
import { isMobile } from '../utilties/mobileDetector'
import { useWindowDimensions } from '../utilties/useWindowDimensions'
import defaultLogo from '../assets/images/logo_benchmarc.svg'
import { getTeamLogo } from '../redux/actions'
import { Link } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
    mainHeaderWrapper: {
        backgroundColor: 'white',
        width: '100%',
    },
    mainHeaderOuter: {
        height: '84px',
        borderBottom: '1px #9CA9BE solid',
        backgroundColor: 'white',
        padding: '0 32px',
        zIndex: '1000',
        flexWrap: 'nowrap',
        justifyContent: 'space-between',
        position: 'fixed',
        top: '0',
        left: '0',
        right: '0',
        width: '100%',
        margin: '0 auto',
        [theme.breakpoints.down('sm')]: {
            height: '61px',
            backgroundColor: 'white',
            padding: '0 16px',
        },
    },
    mainHeaderInner: {
        height: '84px',
        maxWidth: '1400px',
        padding: '0 32px',
        zIndex: '1000',
        flexWrap: 'nowrap',
        justifyContent: 'space-between',
        position: 'fixed',
        top: '0',
        left: '0',
        right: '0',
        width: '100%',
        margin: '0 auto',
        [theme.breakpoints.down('sm')]: {
            height: '61px',
            backgroundColor: 'white',
            padding: '0 16px',
            borderBottom: '1px #9CA9BE solid',
        },
    },
    mainHeaderLogo: {
        padding: '10px 0 10px 27px',
        marginRight: 'auto',
        borderLeft: '1px solid #EEF1F9',
        display: 'flex',
        maxWidth: '200px',
        height: '100%',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100px',
        },
    },
    passportTitle: {
        fontSize: '24px',
        fontWeight: '600',
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
        },
    },
	toggleMenuButton: {
        position: 'absolute',
        right: '5px',
        top: '8px',
        color: '#000',
		borderRadius: '0',
		height: '45px',
	},
    menuOverlay: {
        border: '1px yellow solid',
        position: 'absolute',
        content: '""',
        backgroundColor: '#000',
        opacity: '0.5',
        left: '0',
        top: '0',
        width: '100vw',
        height: '100vh',
    },
    closeMenuButton: {
        float: 'right',
        '& svg': {
            color: '#fff',
        },
    }
}));

const Header = ({ hideMenu, hidePagesMenu, logoUrl, intl, teamLogo, loadTeamLogo, teamLogoIsLoading, isExternalAuth,
    canChangeLanguage = true,
    canChangePassword = true,
    disablePagesMenu = false
}) => {
	const classes = useStyles();

	const { height, width } = useWindowDimensions();
	const [open, setOpen] = useState(isMobile || width<960 ? false : true)
	const toggleMenu = () => {
		if (isMobile || width<960) { setOpen(!open) }
	}

    useEffect(() => {
        loadTeamLogo()
	}, [])

	return (
        <header className={classes.mainHeaderWrapper}>
            <nav className={`${classes.mainHeaderOuter} mainHeaderOuter`}>
                <Grid container className={`${classes.mainHeaderInner} mainHeaderInner`}>
                    {open && (isMobile || width < 960) &&
                        <div className={classes.menuOverlay} onClick={toggleMenu}></div>
                    }

                    <Grid data-testid="main-header-logo-info" item
                        style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <Grid item className={classes.passportTitle}>
                            <Link
                                to={"/"}
                            >
                                <img alt="Logo Benchmark" src='/images/logo_benchmarc.svg' style={{ width: '64px', maxHeight: '60px', margin: '0 10px 0 0', display: 'block' }} />
                            </Link>

                        </Grid>
                    </Grid>
                    <Grid data-testid="main-header-logo" item
                        className={classes.mainHeaderLogo}>
                        <Link
                            to={"/"}
                        >
                            <img alt="Team Logo" src={logoUrl || teamLogo || !teamLogoIsLoading && defaultLogo}
                                style={{ width: 'auto', maxWidth: '100%', height: '100%' }}
                            />
                        </Link>

                    </Grid>
                    {!open && (isMobile || width < 960) && !hideMenu &&
                        <IconButton data-testid="navigation-button-toggle" disableRipple className={`${classes.toggleMenuButton} menuButton`} color="primary"
                            onClick={toggleMenu} style={{ display: isMobile || width < 960 ? 'block' : 'none' }}
                            aria-label="Toggle menu navigation"
                        >
                            <MenuIcon fontSize="large" />
                        </IconButton>
                    }
                    <Grid className={`${isMobile || width < 960 ? 'mainHeaderMenuMobile' : 'mainHeaderMenu'} ${open ? 'navOpened' : 'navClosed'}`} data-testid="main-header-menu" data-print="none" item>
                        {open && (isMobile || width < 960) && !hideMenu &&

                            <IconButton data-testid="navigation-button-toggle" disableRipple className={`${classes.closeMenuButton} menuButton`} color="primary"
                                onClick={toggleMenu} style={{ display: isMobile || width < 960 ? 'block' : 'none' }}
                                aria-label="Toggle menu navigation"
                            >
                                <CloseIcon fontSize="large" />
                            </IconButton>

                        }
                        <Grid
                            data-testid="header-account-menu"
                            container justify='space-between' alignItems='center'
                            style={{ clear: 'both' }}>
                            {
                                !hideMenu
                                && <AccountMenu
                                    hidePagesMenu={hidePagesMenu}
                                    isExternalAuth={isExternalAuth}
                                    canChangeLanguage={canChangeLanguage}
                                    canChangePassword={canChangePassword}
                                    disablePagesMenu={disablePagesMenu}
                                />
                            }
                        </Grid>

                    </Grid>
                </Grid>
            </nav>

        </header>
	)
}

const mapStateToProps = (state, ownProps) => ({
    caseDetails: caseSelector(state),
    teamLogo: teamLogoSelector(state),
    teamLogoIsLoading: teamLogoIsLoadingSelector(state)
})

const mapDispatchToProps = (dispatch) => ({
	loadTeamLogo: () => dispatch(getTeamLogo())
})


const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)

export default enhance(Header)
